/**
 * @class: News
 * @description: purpose of this components is to visualize the twitter handels 
 * @author: Nawod Madhuvantha
 */

import './style.scss';
import { TwitterTweetEmbed } from 'react-twitter-embed'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { TwitterHandles } from '../../../../shared/constants/links';
import { NewsList } from '../../../../shared/constants/news';
import { useState } from 'react';
import { FaDownload } from 'react-icons/fa';

const News = () =>{
    const [expanded, setExpanded] = useState<number[]>([]);

    /**
      * toggle the full text of a news item
      */
    const toggleExpand = (index: number) => {
        setExpanded(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
    }

    return(
        <section id="news" className='news main-container'>
           <div className="news-title h2">News</div>
           <div className="news-article-wrapper">
                {NewsList.list.map((item, index) => {
                    const isExpanded = expanded.includes(index);
                    const isLong = item.paragraphs.length > 1;
                    const paragraphs = isLong && !isExpanded ? item.paragraphs.slice(0, 1) : item.paragraphs;
                    return (
                        <article className="news-article" key={index}>
                            <div className="news-date default-font">{item.date}</div>
                            {item.title && <div className="news-article-title regular-font-bold">{item.title}</div>}
                            {paragraphs.map((text, pIndex) => (
                                <p className="news-text default-font" key={pIndex}>{text}</p>
                            ))}
                            <div className="news-actions">
                                {isLong && (
                                    <button type="button" className="news-read-more" onClick={() => toggleExpand(index)}>
                                        {isExpanded ? 'Show less' : 'Read more'}
                                    </button>
                                )}
                                {item.attachment && (
                                    <a
                                        className="button-wrapper news-download"
                                        href={item.attachment.link}
                                        download={item.attachment.fileName}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <FaDownload /> {item.attachment.title}
                                    </a>
                                )}
                            </div>
                        </article>
                    );
                })}
           </div>
           <div className="news-card-wrapper">
                <Swiper
                    spaceBetween={30}
                    slidesPerView={1}
                    breakpoints={{
                    760: { slidesPerView: 2 },
                    1050: { slidesPerView: 3 },
                    1400: { slidesPerView: 4 },
                    }}
                    pagination={{
                        clickable: true,
                      }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                >
                    {TwitterHandles.list.map((id, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <div className={`news-card ${index % 2 !== 0 && 'even'}`}>
                            <TwitterTweetEmbed 
                                    tweetId={id.id} 
                                    options={{height: "50rem" , innerHeight : '50rem'}} 
                            />
                            </div>
                        </SwiperSlide>
                    );
                    })}
                </Swiper>
        </div>
        </section>
    )
}

export default News;